import { logoutMaker } from 'utils/auth'

export const Logout = (): void => {
  logoutMaker()
  window.location.href = '/'
}
